import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router5';
import * as Actions from '../common/services/actions';
import configureStore from '../common/services/store';
import router from '../common/routes/router';
import NSIRCThesesListingImport from '../listings/NSIRCThesesListing/NSIRCThesesListingJsFile';

let store;

function NSIRCThesesApp() {
	return (
		<Provider store={store}>
			<RouterProvider router={router}>
				<NSIRCThesesListingImport />
			</RouterProvider>
		</Provider>
	);
}

export function renderNSIRCTheses(id) {
	if (!store) {
		store = configureStore(router);
	}
	store.dispatch(Actions.initialiseSettings('NSIRCThesesAppId'));
	router.start(() => {
		ReactDOM.render(<NSIRCThesesApp />, document.getElementById(id));
	});
}
